import { useEffect, useState } from "react";
import api from "@/lib/api";

// Fetch base airport — needed for the pilot fuel-order feature AND for
// rendering a relative-to-base timezone chip on CBP destination info.
export default function useBaseAirport() {
  const [baseAirport, setBaseAirport] = useState("");
  const [baseForTz, setBaseForTz] = useState(null);

  useEffect(() => {
    api
      .get("/company/base-airport")
      .then((r) => {
        const b = r.data || null;
        setBaseAirport(b?.base_airport || "");
        setBaseForTz(b);
      })
      .catch(() => {});
  }, []);

  return { baseAirport, baseForTz };
}
